import {Server, DataSource} from '@/datasources/DataSource'

export default DataSource(Server('/ads/super-admin-list'))
